import { render, staticRenderFns } from "./BindOffiaccountBox.vue?vue&type=template&id=62d2ef2c&scoped=true"
import script from "./BindOffiaccountBox.vue?vue&type=script&lang=js"
export * from "./BindOffiaccountBox.vue?vue&type=script&lang=js"
import style0 from "./BindOffiaccountBox.vue?vue&type=style&index=0&id=62d2ef2c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d2ef2c",
  null
  
)

export default component.exports